import { useState } from "react";
import DataVisualizer from "./DataVisualizer";
import "./Data.css";
import Footer from './Footer'
import DataAppendix from './DataAppendix'

const FACTS = [
  {
    value: "9,123",
    label: "Daily readings since Jan 2000",
  },
  {
    value: "6",
    label: "Newspaper titles",
  },
  {
    value: "100",
    label: "Baseline mean, 2000 to 2024",
  },
];

const FREE_ITEMS = [
  "Daily and monthly readings, 2000 to 2025",
  "Chart usable as an infographic, with attribution",
  "Method and splice steps published in the paper",
];

const PAID_ITEMS = [
  "Live daily index, updated every morning",
  "The series as a file, in Excel, CSV or over the API",
  "Sector sub-indices",
  "Audit sheets and annotation manual",
];

const NAV_ITEMS = [
  { label: "The Index", href: "product.html" },
  { label: "Methodology", href: "methodology.html" },
  { label: "Research", href: "research.html" },
  { label: "Data", href: "/data", active: true },
];

function Data() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      <div className="data-page">

        {/* =========================
            HEADER
        ========================== */}
        <header className="data-header">
          <div className="data-header-inner">

            {/* LOGO + DESKTOP NAV */}
            <div className="data-header-left">

              <a href="/" className="data-logo">
                <img
                  src="/assets/epu-icon.png"
                  alt="EPU Index.PL · Economic Policy Uncertainty Index for Poland"
                />
              </a>

              <nav className="data-desktop-nav">
                {NAV_ITEMS.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    className={item.active ? "active" : ""}
                  >
                    {item.label}
                  </a>
                ))}
              </nav>

            </div>

            {/* HEADER ACTIONS */}
            <div className="data-header-actions">

              <a
                href="contact.html"
                className="data-demo"
              >
                Contact us
              </a>

              <button
                type="button"
                className="data-mobile-menu-button"
                onClick={() => setMenuOpen((open) => !open)}
                aria-label="Menu"
                aria-expanded={menuOpen}
              >
                <span>
                  <span />
                  <span />
                  <span />
                </span>
              </button>

            </div>
          </div>

          {/* MOBILE NAV */}
          {menuOpen && (
            <nav className="data-mobile-menu">

              {NAV_ITEMS.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={closeMenu}
                >
                  {item.label}
                </a>
              ))}

              <a
                href="contact.html"
                onClick={closeMenu}
              >
                Contact us
              </a>

            </nav>
          )}
        </header>


        {/* =========================
            MAIN CONTENT
        ========================== */}
        <main>

          {/* INTRO */}
          <section className="data-main data-intro-section">
            <div className="data-intro">

              <h1>
                Twenty-six years, on one chart<span style={{ color: "#EF3A5D" }}>.</span>
              </h1>

              <p>
                EPU Index PL since January 2000, standardised over a fixed
                25-year baseline and normalised so the 2000 to 2024 average
                equals 100. The series from 2000 to 2025 is published on this
                page as a chart you can read and cite. The live daily index and
                the machine-readable feed come with access.
              </p>

              <div className="data-facts">
                {FACTS.map((fact) => (
                  <div
                    key={fact.label}
                    className="data-fact"
                  >
                    <div className="data-fact-value">
                      {fact.value}
                    </div>

                    <div className="data-fact-label">
                      {fact.label}
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </section>


          {/* CHART */}
          <section
            id="chart"
            className="data-vis"
          >
            <DataVisualizer />
          </section>


          {/* ACCESS + CTA */}
          <section className="data-main data-access-section">
            <DataAppendix />
          </section>

        </main>


        {/* =========================
            FOOTER
        ========================== */}
        

      </div>
      

      <Footer />
    </>
  );
}

export default Data;

